import { DefaultState, TableFilters } from 'store/reducers/types';

export const READ_ASSOCIATES_FILTERS_REQUEST = 'READ_ASSOCIATES_FILTERS_REQUEST';
export const READ_ASSOCIATES_FILTERS_SUCCESS = 'READ_ASSOCIATES_FILTERS_SUCCESS';
export const READ_ASSOCIATES_FILTERS_FAILURE = 'READ_ASSOCIATES_FILTERS_FAILURE';

export type AssociatesFiltersState = DefaultState & {
  contents?: TableFilters;
};

interface ReadAssociatesFiltersRequest {
  type: typeof READ_ASSOCIATES_FILTERS_REQUEST;
};

interface ReadAssociatesFiltersSuccess {
  type: typeof READ_ASSOCIATES_FILTERS_SUCCESS,
  contents: TableFilters;
};

interface ReadAssociatesFiltersFailure {
  type: typeof READ_ASSOCIATES_FILTERS_FAILURE;
};

export type AssociatesFiltersActionTypes = ReadAssociatesFiltersRequest | ReadAssociatesFiltersSuccess | ReadAssociatesFiltersFailure;